import { actionTypes } from './action-types';
import { BASE_URL, debugLogToConsole } from '../utils';

export function initiateFacilitySearch() {
  return {
    type: actionTypes.initiateFacilitySearch
  }
}

export function searchFacilities(value) {
  return async (dispatch) => {
    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);

    const url = new URL(`${BASE_URL}/facility/searchFacilities`);
    const params = { searchTerm: value.trim() };
    url.search = new URLSearchParams(params).toString();

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: reqHeaders
    };

    fetch(url, requestOptions)
      .then(res => res.text())
      .then((result) => {
        const data = JSON.parse(result);
        dispatch({
          type: actionTypes.searchFacilities,
          payload: data
        });
      })
      .catch(error => debugLogToConsole('error', error));
  };
};

export function resetFacilitySearch() {
  return {
    type: actionTypes.resetFacilitySearch
  };
}

export function initiateSurgeonSearch() {
  return { type: actionTypes.initiateSurgeonSearch };
}

export function searchSurgeons(value) {
  return async (dispatch) => {
    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);

    const url = new URL(`${BASE_URL}/users/searchMedProsSurgeons`);
    const params = { searchTerm: value.trim() };
    url.search = new URLSearchParams(params).toString();

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: reqHeaders
    };

    fetch(url, requestOptions)
      .then(res => res.text())
      .then((result) => {
        const data = JSON.parse(result);
        dispatch({
          type: actionTypes.searchSurgeons,
          payload: data
        });
      })
      .catch(error => debugLogToConsole('error', error));
  };
}

export function resetSurgeonSearch() {
  return { type: actionTypes.resetSurgeonSearch };
}

export function initiateAnesthesiologistSearch() {
  return {
    type: actionTypes.initiateAnesthesiologistSearch
  };
}

export function searchAnesthesiologists(value) {
  return async (dispatch) => {
    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);

    const url = new URL(`${BASE_URL}/users/searchMedProsAnesthesiologists`);
    const params = { searchTerm: value.trim() };
    url.search = new URLSearchParams(params).toString();

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: reqHeaders
    };

    fetch(url, requestOptions)
      .then(res => res.text())
      .then((result) => {
        const data = JSON.parse(result);
        dispatch({
          type: actionTypes.searchAnesthesiologists,
          payload: data
        });
      })
      .catch(error => debugLogToConsole('error', error));
  };
}

export function resetAnesthesiologistSearch() {
  return {
    type: actionTypes.resetAnesthesiologistSearch
  };
}

export function initiateCrnaSearch() {
  return {
    type: actionTypes.initiateCrnaSearch
  };
}

export function searchCrnas(value) {
  return async (dispatch) => {
    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);

    const url = new URL(`${BASE_URL}/users/searchMedProsCrnas`);
    const params = { searchTerm: value.trim() };
    url.search = new URLSearchParams(params).toString();

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: reqHeaders
    };

    fetch(url, requestOptions)
      .then(res => res.text())
      .then((result) => {
        const data = JSON.parse(result);
        dispatch({
          type: actionTypes.searchCrnas,
          payload: data
        });
      })
      .catch(error => debugLogToConsole('error', error));
  };
}

export function resetCrnaSearch() {
  return {
    type: actionTypes.resetCrnaSearch
  };
}

export function initiateCptSearch() {
  return {
    type: actionTypes.initiateCptSearch
  };
}

export function searchCpt(value) {
  return async (dispatch) => {
    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);

    const url = new URL(`${BASE_URL}/cpt/searchCpt`);
    const params = { searchTerm: value.trim() };
    url.search = new URLSearchParams(params).toString();

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: reqHeaders
    };

    fetch(url, requestOptions)
      .then(res => res.text())
      .then((result) => {
        const data = JSON.parse(result);
        debugLogToConsole(data);
        dispatch({
          type: actionTypes.searchCpt,
          payload: data
        });
      })
      .catch(error => debugLogToConsole('error', error));
  };
}

export function resetCptSearch() {
  return {
    type: actionTypes.resetCptSearch
  };
}

export function initiateAnesthesiaProcedureSearch() {
  return {
    type: actionTypes.initiateAnesthesiaProcedureSearch
  };
}

export function searchAnesthesiaProcedures(value) {
  return async (dispatch) => {
    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);

    const url = new URL(`${BASE_URL}/anesProc/searchAnesthesiaProcedures`);
    const params = { searchTerm: value.trim() };
    url.search = new URLSearchParams(params).toString();

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: reqHeaders
    };

    fetch(url, requestOptions)
      .then(res => res.text())
      .then((result) => {
        const data = JSON.parse(result);
        dispatch({
          type: actionTypes.searchAnesthesiaProcedures,
          payload: data
        });
      })
      .catch(error => debugLogToConsole('error', error));
  };
}

export function resetAnesthesiaProcedureSearch() {
  return {
    type: actionTypes.resetAnesthesiaProcedureSearch
  };
}

export function initiateIcd10Search() {
  return {
    type: actionTypes.initiateIcd10Search
  };
}

export function searchIcd10(value) {
  return async (dispatch) => {
    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);

    const url = new URL(`${BASE_URL}/icd10/searchIcd10`);
    const toSearch = value.trim().replace(/[/\-\\^$*+?.()|[\]{}]/g, '');
    const params = { searchTerm: toSearch };
    url.search = new URLSearchParams(params).toString();

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: reqHeaders
    };

    fetch(url, requestOptions)
      .then(res => res.text())
      .then((result) => {
        const data = JSON.parse(result);
        dispatch({
          type: actionTypes.searchIcd10,
          payload: data
        });
      })
      .catch(error => debugLogToConsole('error', error));
  };
}

export function resetIcd10Search() {
  return {
    type: actionTypes.resetIcd10Search
  };
}
